import React, { useState } from 'react';
import { ClickLinkTYpe, FishProfileSingleType } from './model';
import { FruitPropsType } from 'src/views/harvesting/fruit-profile/model';
import { PlatformIcon } from './platform-icon';
import { FishProfileSingleStyleType } from './model';
import { makeStyles } from '@material-ui/core';
import {
  oldFruitsProfileToNewFormatReader,
  mergedFruit,
} from './utils/document-version-reader';
import ClearIcon from '@material-ui/icons/Clear';
import {
  CardHeader,
  Card,
  CircularProgress,
  IconButton,
  ListItemAvatar,
} from '@material-ui/core';
import { FishmanGroup } from '../fruit-fishman-group';
import LockIcon from '@material-ui/icons/Lock';
import { useHarvestingContext } from 'src/views/harvesting/harvesting-context';
import { SmartAvatar } from '../components/smart-avatar';
import { FruitFacebookGroup } from '../fruit-facebook-group';
import { useAuthContext } from 'src/context/AuthContext';
import {
  isFruitLockedByYouWithInExpireTime,
  fruitHasValidateLockFromOthers,
} from './utils/smart-filtering';
import { usePreferenceContext } from 'src/context/PreferenceContext';
import ProfileLightBox from '../fruit-profile-pop-up';

import { useFirestore } from 'reactfire';

interface ProfileCardType {
  style: any;
  className: any;
  pending: boolean;
  children: React.ReactNode;
  setEditProfile: (raw: FruitPropsType) => void;
  raw: FruitPropsType;
  innerref: (element: HTMLElement | null) => void;
}

const ProfileCard: React.FC<ProfileCardType> = ({
  children,
  setEditProfile,
  raw,
  innerref,
  ...props
}) => {
  const classes = useSingleProfileStyle();
  return (
    <Card
      {...props}
      ref={innerref}
      onClick={(x) => setEditProfile(raw)}
      className={classes.card}
    >
      {children}
    </Card>
  );
};

export const FishProfileSingleNoMemo: React.FC<FishProfileSingleType> = ({
  provided,
  fruit,
  style,
  isDragging,
}) => {
  const classes = useSingleProfileStyle();

  const {
    removeFruit,
    setFruitNewLocked,
    removeFruitLocks,
    checkedFruit,
  } = useHarvestingContext();
  const [editProfile, setEditProfile] = useState({});
  const { fruitsTab } = usePreferenceContext();
  const [fruitStatus, setFruitStatus] = useState('Available');
  const { user } = useAuthContext();
  const db = useFirestore();

  const thisFruitName = fruit.name.toLowerCase().trim();

  const thisCheckedFruit = checkedFruit[thisFruitName] ?? [];
  const status =
    checkedFruit[thisFruitName] === undefined ? 'loading' : 'success';
  const DataWithNewVersion =
    status === 'success'
      ? oldFruitsProfileToNewFormatReader(thisCheckedFruit)
      : false;
  const mergedFruitFinal = mergedFruit(fruit, DataWithNewVersion);
  const openLightBox = () => {
    setFruitNewLocked(fruit, DataWithNewVersion);
  };
  const isLightBoxOpen = isFruitLockedByYouWithInExpireTime(
    DataWithNewVersion,
    user.name
  );

  const closeLightBox = () =>
    removeFruitLocks(mergedFruitFinal, thisCheckedFruit);

  const isLockStatus = fruitHasValidateLockFromOthers(
    mergedFruitFinal,
    user.name + '3'
  );
  const isLocked = (isLockStatus && isLockStatus.length > 0) ?? false;

  return (
    <>
      <ProfileCard
        innerref={provided.innerRef}
        {...provided.draggableProps}
        {...provided.dragHandleProps}
        style={getStyle({ provided, style, isDragging })}
        className={classes.card}
        setEditProfile={setEditProfile}
        raw={fruit}
        pending={status === 'loading'}
      >
        {user.role === 'admin' && JSON.stringify(isLockStatus)}
        <CardHeader
          className={classes.fishcard}
          avatar={
            <ClickLink
              className={classes.link}
              raw={mergedFruitFinal}
              isLocked={isLocked}
              openLightBox={() => openLightBox()}
              status={status}
            >
              <ListItemAvatar className={classes.listItemAvatar}>
                <SmartAvatar fruit={fruit} />
              </ListItemAvatar>
            </ClickLink>
          }
          title={
            <ClickLink
              className={
                status !== 'loading' && !isLocked
                  ? classes.name
                  : classes.pendingName
              }
              raw={mergedFruitFinal}
              isLocked={isLocked}
              openLightBox={() => openLightBox()}
              status={status}
            >
              {fruit.name}
              <PlatformIcon fruit={fruit} />
              {status === 'loading' && (
                <CircularProgress className={classes.progress} size={16} />
              )}
              {isLocked && <LockIcon className={classes.lock} />}
            </ClickLink>
          }
          action={
            fruit.status === 'Available' && (
              <IconButton className={classes.iconButton}>
                <ClearIcon
                  onClick={() => {
                    removeFruit(fruit, thisCheckedFruit);
                  }}
                />
              </IconButton>
            )
          }
          subheader={
            <>
              <FishmanGroup fruit={fruit} checkedData={DataWithNewVersion} />
              {fruit.others ? (
                <>
                  {fruit.others} <br />
                </>
              ) : null}
              {fruit?.facebookGroupIds && 'Group:'}
              {fruit?.facebookGroupIds?.map((facebookGroupId, key) => (
                <FruitFacebookGroup
                  facebookGroupId={facebookGroupId}
                  key={key}
                />
              ))}
            </>
          }
        />

        {isLightBoxOpen && (
          <ProfileLightBox
            fruit={fruit}
            checkData={DataWithNewVersion}
            checkDataold={thisCheckedFruit}
            isOpen={isLightBoxOpen}
            other={
              user.role === 'admin' ? (
                <pre>Data: {JSON.stringify(mergedFruitFinal, null, 2)}</pre>
              ) : (
                <></>
              )
            }
            closeLightBox={closeLightBox}
          />
        )}
      </ProfileCard>
    </>
  );
};

const ClickLink: React.FC<ClickLinkTYpe> = ({
  className,
  children,
  raw,
  style,
  status,
  isLocked,
  openLightBox,
}) => {
  const { fruitsTab } = usePreferenceContext();

  return (
    <div
      className={className}
      style={{
        display: 'flex',
        alignfruits: 'center',
        ...style,
      }}
      onClick={(x) => {
        //TODO: POP UP LINK IS WRONG ATM
        if (status !== 'loading' && !isLocked) {
          const fruitUrl = fruitURL(raw);
          if (fruitUrl !== null && fruitsTab === 'Available') {
            //TODO: Unfrozen this9
            window.open(fruitUrl ?? '', '_blank');
          }
          openLightBox();
        }
      }}
    >
      {children}
    </div>
  );
};

const fruitURL = (fruit: FruitPropsType): string | null => {
  if (fruit.version === 3) {
    switch (fruit.platform) {
    case 'Facebook':
      if (fruit.facebookUserId && fruit.facebookUserId !== 'NaN') {
        return `https://www.facebook.com/${fruit.facebookUserId}`;
      } else if (fruit.facebookUsername) {
        return `https://www.facebook.com/${fruit.facebookUsername}`;
      } else {
        return fruit.url ?? null;
      }

    case 'Instagram':
      // code block
      if (fruit.instagramId) {
        return `https://www.instagram.com/${fruit.instagramId}`;
      } else return fruit.url ?? null;

    case 'Bumble':
      // code block
      return fruit.url ?? null;
    case 'Other':
      // code block
      return fruit.url ?? null;
    default:
      return fruit.url ?? null;
    }
  } else {
    return fruit.url ?? null;
  }
};

export const getStyle = ({
  provided,
  style,
  isDragging,
}: FishProfileSingleStyleType) => {
  // If you don't want any spacing between your items
  // then you could just return this.
  // I do a little bit of magic to have some nice visual space
  // between the row items
  const combined = {
    ...style,
    ...provided.draggableProps.style,
  };

  const marginBottom = 8;
  const withSpacing = {
    ...combined,
    height: isDragging ? combined.height : combined.height - marginBottom,
    marginBottom,
  };
  return withSpacing;
};

export const useSingleProfileStyle = makeStyles((theme) => ({
  root: {
    width: '100%',
    background: '#fafafa',
    borderRadius: 4,
    height: '100%',
    paddingTop: 0,
    // minHeight: 'calc(100vh - 256px)'
  },
  inline: {
    display: 'inline',
  },
  avatar: {
    width: theme.spacing(8.5),
    height: theme.spacing(8.5),
    [theme.breakpoints.down('sm')]: {
      width: theme.spacing(4),
      height: theme.spacing(4),
    },
  },
  zoomAvatar: {
    width: theme.spacing(18),
    height: theme.spacing(18),
    [theme.breakpoints.down('sm')]: {
      width: theme.spacing(14),
      height: theme.spacing(14),
    },
  },
  smallAvatar: {},
  listItem: {
    alignItems: 'center',
  },
  name: {
    color: 'black',
    textDecoration: 'none',
    fontWeight: 600,
    letterSpacing: 0,
    cursor: 'pointer',
  },
  pendingName: {
    color: '#00000075',
    textDecoration: 'none',
    fontWeight: 600,
    letterSpacing: 0,
    cursor: 'wait',
  },
  link: {
    textDecoration: 'none',
    cursor: 'pointer',
  },
  iconButton: {
    padding: theme.spacing(0.5),
    '& svg.MuiSvgIcon-root': {
      width: '0.7em',
      height: '0.7em',
    },
  },
  fishcard: {
    padding: '10px 10px',
    alignItems: 'flex-start',
    width: '100%',
  },
  listItemAvatar: {
    minWidth: 'unset',
  },
  card: {
    display: 'flex',
    alignItems: 'center',
  },
  progress: {
    marginLeft: theme.spacing(1),
  },
  lock: {
    fontSize: 16,
    marginLeft: 2,
    color: '#e75252',
  },
}));

export const FishProfileSingle = React.memo(FishProfileSingleNoMemo);
